import React, { useMemo, useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userSelector } from "../../slices/user/userSlice";
import UserState from "../../slices/user/UserState";
import { CoreTerminalPathParams, terminalNumberParamName } from "./RoutesConfig";
import TerminalRoutingProvider from "./TerminalRoutingProvider";

const TerminalRouting: React.FC<any> = ({ children, ...rest }) => {
  const user: UserState = useSelector(userSelector);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams() as CoreTerminalPathParams;
  const [checksCompleted, setChecksCompleted] = useState<Boolean>(false);

  const urlTerminalNumber = useMemo(() => {
    return parseInt(params[terminalNumberParamName], 10);
  }, [params]);

  const doChecks = React.useCallback((_history: any, _location: any, _dispatch: any, _user: any, _urlTerminalNumber: number) => {
    if (_user.loggedIn) {
      const terminalProvider = new TerminalRoutingProvider(
        _history,
        _dispatch,
        _location,
        _user
      );
      terminalProvider
        .setUrlTerminalNumber(_urlTerminalNumber)
        .checkUrlTerminalNumberExist()
        ?.checkUrlTerminalNumberAccess()
        ?.checkUrlTerminalNumberTheSameAsActiveTerminal();
    }
    setChecksCompleted(true);
  }, []);

  useEffect(() => {
    setChecksCompleted(false);
  }, [urlTerminalNumber]);

  useEffect(() => {
    if (checksCompleted) return;
    doChecks(history, location, dispatch, user, urlTerminalNumber);
  }, [checksCompleted, history, location, dispatch, user, urlTerminalNumber, doChecks]);

  return checksCompleted ? children : (<></>);
};

export default TerminalRouting;
